const cardColor = [
    {
        color: 'primary',
        text: 'white'
    },
    {
        color: 'success',
        text: 'white'
    },
    {
        color: 'danger',
        text: 'white'
    },
    {
        color: 'purple',
        text: 'white'
    },
    {
        color: 'warning',
        text: 'white'
    },
    {
        color: 'info',
        text: 'white'
    },
    {
        color: 'dark',
        text: 'white'
    },
    {
        color: 'pink',
        text: 'white'
    }
];

export { cardColor };
